module.exports = {
          srcSet: __webpack_public_path__ + "6912b9c2.jpg"+" 700w"+","+__webpack_public_path__ + "8ce1f3e1.jpg"+" 1400w"+","+__webpack_public_path__ + "b03b285d.jpg"+" 1944w",
          images:[ {path: __webpack_public_path__ + "6912b9c2.jpg",width: 700,height: 467},{path: __webpack_public_path__ + "8ce1f3e1.jpg",width: 1400,height: 933},{path: __webpack_public_path__ + "b03b285d.jpg",width: 1944,height: 1296}],
          src: __webpack_public_path__ + "6912b9c2.jpg",
          toString:function(){return __webpack_public_path__ + "6912b9c2.jpg"},
          
          width: 700,
          height: 467
        }